import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { EColors } from "libs/style/styling"
import React from "react"
import styled from "styled-components/macro"

export type IconSize = "10px" | "13px" | "16px" | "20px" | "25px" | "35px"

interface Props {
  iconSize: IconSize
  icon: IconDefinition
  color: EColors
  onClick?: () => void
}

export const AwesomeIcon = (props: Props): JSX.Element => {
  return (
    <S_AwesomeIcon
      size={props.iconSize}
      color={props.color}
      onClick={props.onClick}
    >
      <FontAwesomeIcon icon={props.icon} />
    </S_AwesomeIcon>
  )
}

export const S_AwesomeIcon = styled.div`
  > svg {
    font-size: ${props => props.size};
    color: ${props => props.color};
  }
`
